module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-revenue"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Omsætning\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f03b8ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/components/compareRevenue.vue
// module id = 862
// module chunks = 0